export default __webpack_public_path__ + "static/media/menu-07-sender-ids-b.ed92fc3c.svg";